// extracted by mini-css-extract-plugin
export default {"page":"Contact_page__rcdtU","specks":"Contact_specks__bZfzO","layout":"Contact_layout__7euF4","colInfo":"Contact_colInfo__yzanS","colForm":"Contact_colForm__oIvqm"};